import { call, put, all } from "redux-saga/effects";
import qs from 'query-string';
import { toast } from 'react-toastify';

import actions, { actionTypes } from "../../../shell/actions";
import { NextServerAPI } from '../../../utils';

export function* getPlans(action) {
  const { query, token } = action.payload;

  yield put(actions.loadingPlans({ loading: true }));

  try {
    const response = yield call(NextServerAPI, {
      method: 'GET',
      path: `/api/products/plans/?${query}`,
      ...token ? { AuthorizationToken: `bearer ${token}` } : {},
    });

    if (response.data && response.data.plans) {
      yield put(actions.loadedPlans({ response }));
    } else {
      yield put(actions.errorLoadingPlans({ errorMessage: response.data.errorMessage }));
    }
  }
  catch (e) {
    const errorMessage = 'Some thing went wrong, please try again';
    toast.error(errorMessage);
    console.error(e);
  }
}

export function* getComparePlans(action) {
  const { token, compareItems, members, year, namePlan, budget } = action.payload;

  yield put(actions.loadingComparePlans({ loading: true }));

  try {
    const plans = yield all(compareItems.map(plan => call(NextServerAPI, {
      method: 'GET',
      path: `/api/products/plans/?${qs.stringify({
        year,
        planId: plan.id,
        member: members,
        name: namePlan,
        ...(plan.additionalBenefits ? { additional_benefits: JSON.stringify(plan.additionalBenefits) } : {}),
        ...(plan.vehiclePrice ? { sum_insured: Math.trunc(plan.vehiclePrice) } : {}),
        ...(budget ? { budget } : {}),
        ...(plan.term ? { term: plan.term } : {}),
      })}`,
      ...token ? { AuthorizationToken: `bearer ${token}` } : {},
    })));

    yield put(actions.loadedComparePlans({ plans }));
  } catch (e) {
    yield put(actions.errorLoadingComparePlans({ errorMessage: 'Some thing went wrong, please try again' }));
    console.error(e);
  }
}

export function* getAdditionalBenefits(action) {
  const { query } = action.payload;

  yield put(actions.loadingAdditionalBenefits());

  try {
    const additionalBenefits = yield call(NextServerAPI, {
      method: 'GET',
      path: `/api/products/additional-benefits/?${qs.stringify(query)}`
    });

    yield put(actions.loadedAdditionalBenefits({ additionalBenefits }));
  } catch (error) {
    yield put(actions.errorLoadingQuotationHistory({ errorObject: error }));
  }
}

export default [
  [actionTypes.GET_PLANS, getPlans],
  [actionTypes.GET_COMPARE_PLANS, getComparePlans],
  [actionTypes.GET_ADDITIONAL_BENEFITS, getAdditionalBenefits],
];
